<template>
    <div>
        <navbar></navbar>
        <router-view class="router_content" v-slot="{ Component }">
            <transition name="fade" mode="out-in">
                <component :is="Component" />
            </transition>
        </router-view>
    </div>
</template>
<script>
    import navbar from './navbar.vue'
    export default{ 
        components: { navbar },
    }
</script>

<style>
/* @media (max-width: 991px){
    .router_content{
        position: absolute !important;
        width: 100vw;
    }
} */

</style>